export default "__VITE_ASSET__DJsVUql6__"